/**
 * 取消订阅 Modal 背景
 * 使用与主页相同的背景图片方式
 */
export function CancelModalBackgroundSimple() {
  return (
    <div
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{
        backgroundImage: 'url(/homepage/bg-min.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundColor: '#212121',
      }}
    />
  )
}
